import { cn } from "@/lib/utils";
import { formatPercent } from "@/lib/format";

interface UtilizationBarProps {
  value: number;
}

export function UtilizationBar({ value }: UtilizationBarProps) {
  const clamped = Math.max(0, Math.min(value, 100));
  const tone =
    value > 80
      ? "bg-destructive"
      : value >= 30
        ? "bg-warning"
        : "bg-success";

  return (
    <div className="flex items-center gap-2">
      <div
        className="h-1.5 w-24 overflow-hidden rounded-full bg-muted"
        role="progressbar"
        aria-valuenow={Number(clamped.toFixed(2))}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className={cn("h-full rounded-full transition-[width]", tone)}
          style={{ width: `${clamped}%` }}
        />
      </div>
      <span className="font-mono tabular-nums text-xs text-muted-foreground">
        {formatPercent(value, 2)}
      </span>
    </div>
  );
}
